import { getAuthToken } from '../utils/auth';

const API_BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface TransactionSummaryResponse {
  total_completed_count: number;
}

export interface UserSummaryResponse {
  total_users: number;
  total_pending_upgrade: number;
  total_pending_review: number;
}

export interface CardSummaryResponse {
  total_virtual_cards: number;
  total_physical_cards: number;
  total_pending_collection: number;
  total_dispatched: number;
}

export type AnalyticsType = 'card-summary' | 'transaction-summary' | 'user-summary';

export const getAnalytics = async (
  type: AnalyticsType
): Promise<TransactionSummaryResponse | UserSummaryResponse | CardSummaryResponse> => {
  const response = await fetch(`${API_BASE_URL}/admin/analytics?type=${type}`, {
    method: 'GET',
    headers: {
      'Authorization': `ClientBearer ${getAuthToken()}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch analytics: ${response.statusText}`);
  }

  return response.json();
};

// Specific analytics functions for type safety
export const getTransactionSummary = (): Promise<TransactionSummaryResponse> => 
  getAnalytics('transaction-summary') as Promise<TransactionSummaryResponse>;

export const getUserSummary = (): Promise<UserSummaryResponse> => 
  getAnalytics('user-summary') as Promise<UserSummaryResponse>;

export const getCardSummary = (): Promise<CardSummaryResponse> => 
  getAnalytics('card-summary') as Promise<CardSummaryResponse>;
